import classNames from "classnames";

import style from "./CTARow.module.css";

export default function CTARow({
  title,
  text,
  CTA,
  notification,
  className,
}: {
  title: React.ReactNode;
  text?: React.ReactNode;
  className?: string;
  CTA?: React.ReactNode;
  notification?: React.ReactNode;
}) {
  return (
    <div className={classNames(style.container, className)}>
      <div className={style.leftContainer}>
        <div className={style.title}>{title}</div>
        {text && <div className={style.text}>{text}</div>}
        {notification && <div>{notification}</div>}
      </div>
      {CTA}
    </div>
  );
}
